//Authentication class

import jwt from "jwt-decode";
import { AddBearerToken } from "./axiosService";
import { redirect } from "react-router";

export enum AuthRoles {
    User = 0,
    Store = 1,
    SignalR = 2,
    Support = 9,
    Admin = 99
}

export interface authData {
    token: string,
    firstname: string,
    lastname: number,
    sites: string,
    userName: string,
}

export interface tokenData {
    UserId: string,
    Email: string | null,
    GivenName: string,
    FamilyName: string,
    AuthRole: number,
    Owner: string,
    UserStoreGroupId: string,
    StoreGroups: string,
    RootStoreGroup: number,
    UsesRootStoreGroup: string
    nbf: number,
    exp: number,
    iat: number,
}

export function setAuthData(data: authData, rememberEmail: string) {
    localStorage.setItem("authData", JSON.stringify(data));
    AddBearerToken(data.token);
    if (rememberEmail) {
        localStorage.setItem("email", rememberEmail);
    } else {
        localStorage.removeItem("email");
    }
}

export function getAuthData(): authData | null {
    try {
        let authString = localStorage.getItem("authData") ?? null;
        if (authString) {
            return JSON.parse(authString) as authData;
        }
    } catch  {
    }

    return null;
}

declare const heap: any;
export function logout(redirectFromWindow: boolean = false, suppressNavigationConfirmation: boolean = false) {
    // Suppress confirmation prompts like "Are you sure you want to leave this page?"
    if (suppressNavigationConfirmation) window.onbeforeunload = null;
    localStorage.removeItem("authData");

    try {
        if (typeof heap !== 'undefined') {
            heap.resetIdentity();
        }    
    } catch (error) {
        console.log(error);
    }

    if (redirectFromWindow) {
        let destination = window.location.href.replace(window.location.origin, "");
        window.location.href = "/login?redirect=" + destination;
    } else {
        window.location.href = '/login';
    }
}

export function getToken(): string | null {
    return getAuthData()?.token ?? null;
}

export function isLoggedIn(): boolean {
    let data = getAuthData();
    if (data) {
        return true;
    }
    return false;
}

export function decodeToken(): tokenData | null {
    let data = getAuthData();
    if (data) {
        let token = data.token;
        if (token) {
            const tokenDataReturn = jwt<tokenData>(token);
            return tokenDataReturn;
        }
    }
    return null;
}